import { RelationshipKey } from '../home/routes/connections/relationship-nav';

export type ProfileRelationshipStats = {
  referred: number;
  following: number;
  followers: number;
  favorites: number;
  favorited: number;
  gifted?: number | null;
};

export const RELATIONSHIP_STATS: { key: RelationshipKey; label: string }[] = [
  { key: 'referred', label: 'Referred' },
  { key: 'following', label: 'Following' },
  { key: 'followers', label: 'Followers' },
  { key: 'favorites', label: 'Favorites' },
  { key: 'favorited', label: 'Favorited' },
  { key: 'gifted', label: 'Gifted' },
];

export function connectionRelationshipStats(stats: {
  relationshipStats?: ProfileRelationshipStats | null;
  referralCount?: number;
  gifted?: number | null;
} | null | undefined): ProfileRelationshipStats {
  if (stats?.relationshipStats) {
    return {
      referred: stats.relationshipStats.referred ?? 0,
      following: stats.relationshipStats.following ?? 0,
      followers: stats.relationshipStats.followers ?? 0,
      favorites: stats.relationshipStats.favorites ?? 0,
      favorited: stats.relationshipStats.favorited ?? 0,
      gifted: typeof stats.relationshipStats.gifted === 'number'
        ? stats.relationshipStats.gifted
        : null,
    };
  }
  const gifted = stats && Object.prototype.hasOwnProperty.call(stats, 'gifted')
    ? stats.gifted
    : null;
  return {
    referred: stats?.referralCount ?? 0,
    following: 0,
    followers: 0,
    favorites: 0,
    favorited: 0,
    gifted: typeof gifted === 'number' ? gifted : null,
  };
}
